import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AppLayoutModule } from './shared/components/layout/app.layout.module';
import { NotfoundComponent } from './pages/notfound/notfound.component';
import { ProductService } from './shared/service/product.service';
import { CountryService } from './shared/service/country.service';
import { CustomerService } from './shared/service/customer.service';
import { EventService } from './shared/service/event.service';
import { IconService } from './shared/service/icon.service';
import { NodeService } from './shared/service/node.service';
import { PhotoService } from './shared/service/photo.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './shared/interceptors/auth.interceptor';
import { TooltipModule } from 'primeng/tooltip';
import { CapitalizeFirstLetterDirective } from './shared/directives/capitalize-first-letter.directive';
import { DragableDirective } from './shared/directives/dragable.directive';

@NgModule({
    declarations: [
        AppComponent, NotfoundComponent, CapitalizeFirstLetterDirective, DragableDirective,
    ],
    imports: [
        AppRoutingModule,
        AppLayoutModule,
        TooltipModule,
        
    ],
    providers: [
        CountryService, CustomerService, EventService, IconService, NodeService,
        PhotoService, ProductService, {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
